module.exports = __webpack_public_path__ + "img/bg_mobile_rus.38077eae.jpg";